export default __webpack_public_path__ + "static/media/pantry1-afterF-768w.6dea8202.webp";